window.addEventListener("DOMContentLoaded", function () {
    let allTickets = [];
    let nodeList = [];
    let nodeListArray = [];
    let remainingAvailableTickets = [];
    let categoryDropdownFilterSelector = null;
    let categoryDropdownFilterSelections = null;
    let categoryDropdownFilterActiveSelection = null;
    let typeOfVisitTagLabels = [];
    let typeOfVisitDropdownFilterSelector = null;
    let typeOfVisitDropdownFilterInputs = null;
    let typeOfVisitDropdownFilterSelections = null;
    let typeOfVisitPillsFilterSelections = null;
    let showTypeOfVisitDropdownFilterModal = false;
    let showCategoryDropdownFilterModal = false;
    let numberOfTicketsAvailable = 0;
    let isCategoryFilterActive = false;
    let isTypeOfVisitFilterActive = false;
    let isFiltersReset = true;
    let ticketSections = null;
    let hideResultsTicketsOnCategoryLabel = '';
    
    //Dom elements
    const ticketCategoryElem = document.querySelector('[data-js="ticket-category"]');

    function init() {
        const localAllTickets = [];
        nodeList = document.querySelectorAll(".filterable .merlin-ticket");

        //hiddenBeforeFiltering toggle hack
        document.querySelectorAll('.hiddenBeforeFiltering').forEach(element => {
            element.style.display = 'none';
        });

        nodeList.forEach((item) => {
            const ticket = {
                id: item.id,
                category: item.dataset.category,
                typeOfVisitFilters: JSON.parse(item.dataset.typeofvisitfilters) //{"family":true,"nature":false,"special":true}
            };
            localAllTickets.push(ticket);
        });

        allTickets = localAllTickets;
        
        getAllTagsFromTickets();

        try {
            getAllCategoriesFromTickets();
            categoryDropdownFilterSelections = document.querySelectorAll(".tickets-and-passes__filters__category-filter .category-filter-input");

            categoryDropdownFilterSelections.forEach(inputElement => {
                inputElement.addEventListener('click', filterTickets)
            })
        } catch (e) {
            console.log("Category dropdown-filter is not present in the DOM");
        }
        try {
            typeOfVisitDropdownFilterSelections = document.querySelectorAll(".tickets-and-passes__filters__type-of-visit .typeofvisit-filter-input")
            typeOfVisitDropdownFilterInputs = document.querySelectorAll(".tickets-and-passes__filters__type-of-visit input");

            typeOfVisitDropdownFilterInputs.forEach(inputElement => {
                inputElement.addEventListener('click', filterTickets)
            });
        } catch (e) {
            console.log("Type-of-visit dropdown-filter is not present in the DOM");
        }

        try {
            typeOfVisitPillsFilterSelections = document.querySelectorAll('.type-of-visit-filter-pills-wrapper input');

            typeOfVisitPillsFilterSelections.forEach(inputElement => inputElement.addEventListener('click', filterTickets));
        } catch (e) {
            console.log("Type-of-visit pills-filter is not present in the DOM");
        }

        document.querySelectorAll('.merlin-tickets-heading')?.forEach(heading => {
            if(heading.textContent.toLowerCase().includes('{{numberofticketsavailable}}')) {
                heading.innerHTML = heading.innerHTML.replace('{{numberOfTicketsAvailable}}', '<span data-js="number-of-tickets"></span>');
            }
        });

        // Make it possible to click outside the individual modal to close them
        document.addEventListener('click', closeTypeOfVisitDropdownFilterModal);
        document.addEventListener('click', closeCategoryFilterModal);

        checkUrlForFilterParamsOnPageLoadAndUpdateSelectors();

        revealHideTickets();

        ticketSections = document.querySelectorAll('.merlin-tickets-wrapper');

        // On page load: Handle option to hide Results Tickets on Category filter selection 1of2 (Ideally refactor)
        if(ticketSections !== null && ticketSections.length > 0) {
            ticketSections.forEach(section => {
                if(section.dataset.hideResultsTickets === "True"){
                    hideResultsTicketsOnCategoryLabel = section.querySelector('.merlin-tickets-heading').textContent;
                }
            })
            if(categoryDropdownFilterSelections !== null) {
                categoryDropdownFilterSelections.forEach(function (radio) {
                    const resultsTicketsSection = document.querySelector('.results-tickets-section');
                    if (radio.checked) {
                        // Handle option to hide Results Tickets on Category filter selection 2of2
                        if(radio.value !== hideResultsTicketsOnCategoryLabel && resultsTicketsSection !== null) {
                            resultsTicketsSection.style.display = 'block';
                        }
                        if(radio.value === hideResultsTicketsOnCategoryLabel && resultsTicketsSection !== null) {
                            resultsTicketsSection.style.display = 'none';
                        }
                    }
                });
            }
        }

        //Show/hide categories
        showFilterableByCategoryTickets();
        showFilterableByTypeOfVisitTickets();
        showResultsTickets();

        //Toggle modals
        categoryFilterModalEvents();
        toggleTypeOfVisitDropdownFilterModalEvents();

        //Show component
        ticketCategoryElem.style.display = 'block';
    }

    function getAllTagsFromTickets() {
        let allTags = [];

        allTickets.forEach( ticket => {
            Object.keys(ticket.typeOfVisitFilters).forEach(key => {
                if (ticket.typeOfVisitFilters[key] === true) {
                    allTags.push(key);
                }
            });
        });

        // Remove duplicates
        allTags = allTags.filter((item, i, ar) => ar.indexOf(item) === i);

        // Sort tags according to how they're set in Umbraco
        const tagsOrder = JSON.parse(document.querySelector('.ticket-filters-wrapper').dataset.orderedTags);
        const sortedTags = [];
        
        // Populate new sortedTags array with tags and order from backend data
        allTags.forEach((tag) => {
            tagsOrder.forEach( itemObject => {
                if(itemObject['Value'].toLowerCase() === tag.toLowerCase()) {
                    const obj = {};
                    obj.label = tag
                    obj.tag = tag.toLowerCase();
                    obj.order = itemObject['Key']
                    sortedTags.push(obj)
                }
            })
        })

        function sortByKey(array, key) {
            return array.sort(function(a, b) {
                var x = a[key]; var y = b[key];
                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });
        }

        sortByKey(sortedTags, 'order');

        if(document.querySelectorAll(".tickets-and-passes__filters__type-of-visit ").length > 0) {
            const typeOfVisitFilterModal = document.querySelector('.modal-dropdown-type-of-visit')
            const tagsFilterHTML = sortedTags.map(tag => {
                let html = `<li>
                    <label>
                        <input type="checkbox" value="${tag.label}" class="typeofvisit-filter-input" />
                        <span>
                            ${tag.label}
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 15" width="18" height="15" aria-hidden="true" focusable="false"><path d="M16 0l1.43 1.4L4.98 14.13 0 9.037l1.43-1.398 3.55 3.63z"></path></svg>
                        </span>
                    </label>
                </li>`
                return html;
            });

            let readyHTML = '';

            tagsFilterHTML.forEach(element => {
                readyHTML += element;
            });

            typeOfVisitFilterModal.firstElementChild.innerHTML = readyHTML;
        }

        if(document.querySelectorAll('.type-of-visit-filter-pills-wrapper').length > 0) {
            const typeOfVisitFilterPillsWrapper = document.querySelector('.type-of-visit-filter-pills-wrapper');
            const tagsFilterHTML = sortedTags.map(tag => {
                let html = `<label class="checkbox-filter pills-filter-label">
                    <input type="checkbox" name="${tag.label}" value="${tag.label}" class="tag-as-pill" />
                    <span class="pills-label-text">
                        ${tag.label}
                    </span>
                </label>`
                return html;
            });

            let readyHTML = '';

            tagsFilterHTML.forEach(element => {
                readyHTML += element;
            });

            typeOfVisitFilterPillsWrapper.innerHTML = readyHTML;
        }
    }

    function getAllCategoriesFromTickets() {
        let allCategories = [];

        allTickets.forEach( ticket => {
            allCategories.push(ticket.category);
        });

        // Remove duplets
        allCategories = allCategories.filter((item, i, ar) => ar.indexOf(item) === i);

        const categoriesModal = document.querySelector('.modal-category-filter ul');
        const categoriesFilterHTML = allCategories.map(category => {
            let html = `<li>
            <label>
                <input type="radio" name="categoryFilterRadio" value="${category}" class="category-filter-input" />
                <span class="flex-container align-justify">
                    ${category}
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 15" width="18" height="15" aria-hidden="true" focusable="false"><path d="M16 0l1.43 1.4L4.98 14.13 0 9.037l1.43-1.398 3.55 3.63z"></path></svg>
                </span>
            </label>
        </li>`
            return html;
        });

        let readyHTML = '';

        categoriesFilterHTML.forEach(element => {
            readyHTML += element;
        });

        categoriesModal.firstElementChild.innerHTML = readyHTML;
    }

    // Main filter method
    function filterTickets(e) {
        let tickets = allTickets;

        if(e.target.dataset.resetFilter === 'category') {
            categoryDropdownFilterReset();
        }

        if(e.target.dataset.resetFilter === 'type') {
            typeOfVisitDropdownFilterReset();
        }

        if (categoryDropdownFilterSelections !== null && categoryDropdownFilterSelections.length > 0) {
            tickets = categoryDropdownFilter(tickets, e);
        }
        const self = this;

        if (typeOfVisitDropdownFilterInputs.length > 0) {
            tickets = typeOfVisitDropdownFilter(tickets, e);
        }
        
        if (typeOfVisitPillsFilterSelections.length > 0) {
            tickets = typeOfVisitPillsFilter(tickets);
        }

        //Remove potential duplicate tickets
        tickets = tickets.filter((value, index, self) =>
            index === self.findIndex((t) => (
                t.id === value.id
            ))
        )

        handleDomElements(tickets, e);

        // Display tickets with tags that are hidden behind show more tickets
        if (ticketSections !== null && ticketSections.length > 0 && isCategoryFilterActive) {
            ticketSections.forEach( section => { 
                if(section.style.display === 'grid') {
                    const ticketsInSection = section.querySelectorAll('.merlin-ticket');
                    ticketsInSection.forEach( t => {
                        if(t.querySelector('.ticket-filter-tags')?.childElementCount > 0) {
                            t.classList.remove('hidden');
                            if(section.querySelector('.show-more-less-tickets-button') !== null) {
                                section.querySelector('.show-more-less-tickets-button').style.display = 'none';
                            }
                        }
                    })
                }
            })
        } else if (ticketSections !== null && ticketSections.length > 0) { // Reset 'hidden' on 'ticket-hidden' (sjow more/less tickets)
            ticketSections.forEach( section => { 
                const ticketsInSection = section.querySelectorAll('.merlin-ticket');

                ticketsInSection.forEach( t => {
                    if(t.querySelector('.ticket-filter-tags')?.childElementCount === 0) {
                        let hiddenTickets = document.querySelectorAll('.ticket-hidden');
                        hiddenTickets.forEach(ticket => {
                            ticket.classList.add('hidden')
                            const btn = section.querySelector('.show-more-less-tickets-button');
                            if(btn !== null && btn.style.display !== 'block') {
                                btn.style.display = 'block';
                            }
                        })
                    }
                })
            })
        }

        // Category filter:
        // If category filter is selected and active selection clicked, reset category filter
        if(categoryDropdownFilterSelections !== null) {
            categoryDropdownFilterSelections.forEach(inputElement => {
                if (inputElement.checked) {
                    categoryDropdownFilterActiveSelection = inputElement.value;
                }
            });
        }

        ticketCategoryElem.style.display = 'block';
    }

    // Filters
    function categoryDropdownFilter(tickets, e) {
        const self = this;
        let isRadioChecked = false;
        const categoryLabel = document.querySelector('#categoryFilterButton').name;

        if(e.target.closest('.tickets-and-passes__filters__category-filter')) {
            //Update category selector field
            categoryDropdownFilterSelector = document.querySelector(".ticket-select__category-dropdown-filter")
            const resetLabel = categoryDropdownFilterSelections[categoryDropdownFilterSelections.length - 1].value;

            // Check if the reset input is clicked and reset filter button label to 'Category'
            if(e.target.value === resetLabel) {
                categoryDropdownFilterSelector.querySelector("span").innerText = categoryLabel;
            } else {
                categoryDropdownFilterSelector.querySelector("span").innerText = e.target.value;
            }

            // If category filter is selected and active selection clicked, reset category filter
            if(e.target.value === categoryDropdownFilterActiveSelection) {
                categoryDropdownFilterReset();
                categoryDropdownFilterSelector.querySelector("span").innerText = categoryLabel;
            }
            categoryDropdownFilterActiveSelection = null;
        }


        // Handle option to hide Results Tickets on Category filter selection 1of2 (Ideally refactor)
        if(ticketSections !== null && ticketSections.length > 0) {
            ticketSections.forEach(section => {
                // console.log(section.dataset.hideResultsTickets)
                if(section.dataset.hideResultsTickets === "True"){
                    hideResultsTicketsOnCategoryLabel = section.querySelector('.merlin-tickets-heading').textContent;
                }
            })
        }
        
        categoryDropdownFilterSelections.forEach(function (radio) {
            if (radio.checked) {
                isFiltersReset = false;
                isCategoryFilterActive = true;

                showResultsTickets();
                showFilterableByTypeOfVisitTickets();
                showFilterableByCategoryTickets();
                
                tickets = tickets.filter(ticket => ticket.category === radio.value);
                
                updateUrlWithFilterParamsOnFilterPick("category", radio.value);
                isRadioChecked = true;
                showCategoryDropdownFilterModal = false;
                toggleCategoryFilterModal();
                
                // Handle option to hide Results Tickets on Category filter selection 2of2
                const resultsTicketsSection = document.querySelector('.results-tickets-section');
                if(radio.value !== hideResultsTicketsOnCategoryLabel && resultsTicketsSection !== null) {
                    resultsTicketsSection.style.display = 'block';
                }
                if(radio.value === hideResultsTicketsOnCategoryLabel) {
                    resultsTicketsSection.style.display = 'none';
                }
            }
        });

        if(!isRadioChecked){
            isFiltersReset = true;
            isCategoryFilterActive = false;

            showResultsTickets();
            showFilterableByTypeOfVisitTickets();
            showFilterableByCategoryTickets();
            updateUrlWithFilterParamsOnFilterPick("category", null);
        }

        // Disable type of visit filters if no matching tags on remaining tickets
        if(typeOfVisitDropdownFilterSelections.length > 0) {
            disableTypeOfVisitFilterSelectionIfNoTag(tickets, typeOfVisitDropdownFilterSelections);
        }
        if(typeOfVisitPillsFilterSelections.length > 0) {
            disableTypeOfVisitFilterSelectionIfNoTag(tickets, typeOfVisitPillsFilterSelections);
        }

        


        return tickets;
    }

    function typeOfVisitDropdownFilter(tickets, e) {
        const self = this;
        let localTypeOfVisitDropdownFilterSelections = [];
        let isInputsChecked = false;
        let localTicketsArray = [];

        if(e.target.closest('.tickets-and-passes__filters__type-of-visit')) {
            updateTypeOfVisitDropdownFilterSelectorButtonOnClick(e)
        }

        // Create array of input value from selected tyoe of visit filters
        typeOfVisitDropdownFilterInputs.forEach( input => {
            if(input.checked){
                isFiltersReset = false;
                isTypeOfVisitFilterActive = true;

                showResultsTickets();
                showFilterableByTypeOfVisitTickets();
                showFilterableByCategoryTickets();

                localTypeOfVisitDropdownFilterSelections.push(input.value);

                tickets.forEach( ticket => {
                    const obj = ticket.typeOfVisitFilters
                    for( const key in obj ) {
                        if(obj[input.value] === true) {
                            localTicketsArray.push(ticket)
                        }
                    }
                })

                //Update url with filter params
                updateUrlWithFilterParamsOnFilterPick("typeofvisit", localTypeOfVisitDropdownFilterSelections);
                isInputsChecked = true;


            }
        })

        // Remove duplicates if more than one tag is selected
        if (isInputsChecked) {
            // console.log('filtering duplicate tickets');
            tickets = localTicketsArray.filter((item, i, ar) => ar.indexOf(item) === i);
        }

        if(!isInputsChecked){
            isTypeOfVisitFilterActive = false;
            isFiltersReset = true;

            showResultsTickets();
            showFilterableByTypeOfVisitTickets();
            showFilterableByCategoryTickets();
            updateUrlWithFilterParamsOnFilterPick("typeofvisit", null);
        }

        // Disable category filter if no matching category on remaining tickets
        if(categoryDropdownFilterSelections !== null && categoryDropdownFilterSelections.length > 0 && !isCategoryFilterActive) {
            disableCategoryFilterSelectionIfNoTag(tickets, categoryDropdownFilterSelections);
        }

        return tickets;
    }

    function typeOfVisitPillsFilter(tickets) {
        const self = this;
        let localTypeOfVisitPillsFilterSelections = [];
        let isInputsChecked = false;
        let localTicketsArray = [];

        typeOfVisitPillsFilterSelections.forEach( input => {
            if(input.checked) {
                isFiltersReset = false;
                isTypeOfVisitFilterActive = true;
                localTypeOfVisitPillsFilterSelections.push(input.value)

                showResultsTickets();
                showFilterableByTypeOfVisitTickets();
                showFilterableByCategoryTickets();

                tickets.forEach( ticket => {
                    const obj = ticket.typeOfVisitFilters
                    for( const key in obj ) {
                        if(obj[input.value] === true) {
                            localTicketsArray.push(ticket)
                        }
                    }
                })

                //Update url with filter params
                updateUrlWithFilterParamsOnFilterPick("typeofvisit", localTypeOfVisitPillsFilterSelections);
                isInputsChecked = true;
            }
        })

        // Remove duplicates if more than one tag is selected
        if (isInputsChecked) {
            // console.log('filtering duplicate tickets');
            tickets = localTicketsArray.filter((item, i, ar) => ar.indexOf(item) === i);
        }

        if(!isInputsChecked){
            isTypeOfVisitFilterActive = false;
            isFiltersReset = true;

            showResultsTickets();
            showFilterableByTypeOfVisitTickets();
            showFilterableByCategoryTickets();
            updateUrlWithFilterParamsOnFilterPick("typeofvisit", null);
        }

        // Disable category filter if no matching category on remaining tickets
        if(categoryDropdownFilterSelections !== null && categoryDropdownFilterSelections.length > 0 && !isCategoryFilterActive) {
            disableCategoryFilterSelectionIfNoTag(tickets, categoryDropdownFilterSelections);
        }

        return tickets;
    }

    function handleDomElements(tickets, e) {
        //Start by setting all tickets to display none
        nodeList.forEach((item) => {
            item.style.display = "none";
        });

        //then loop through our array
        tickets.forEach((ticket, index) => {
            const singleTicket = document.getElementById(ticket.id);

            singleTicket.style.display = "flex";

            // Populate ticket with type of visit TAGS
            singleTicket.querySelector('.ticket-filter-tags').innerHTML = ""; //Reset
            typeOfVisitDropdownFilterSelections.forEach( input => {
                if(input.checked) {
                    // Populate ticket with filter tags from data attribute
                    for(let key in ticket.typeOfVisitFilters){
                        if(key === input.value){
                            if(ticket.typeOfVisitFilters[key] === true){
                                singleTicket.querySelector('.ticket-filter-tags').innerHTML += `<div class="filter-label-on-ticket"><label class="pills-filter-label"><span class="pills-label-text">${key}</span></label></div>`
                            }
                        }
                    }
                }
            })
            typeOfVisitPillsFilterSelections.forEach( input => {
                if(input.checked) {
                    // Populate ticket with filter tags from data attribute
                    for(let key in ticket.typeOfVisitFilters){
                        if(key === input.value){
                            if(ticket.typeOfVisitFilters[key] === true){
                                singleTicket.querySelector('.ticket-filter-tags').innerHTML += `<div class="filter-label-on-ticket"><label class="pills-filter-label"><span class="pills-label-text">${key}</span></label></div>`
                            }
                        }
                    }
                }
            })

            // Sorting tickets
            // console.log(singleTicket)
            index = index + 10;
            singleTicket.style.order = index.toString();

            // Fix sort order when multiple type-of-visit filters are selected
            const singleTicketTags = singleTicket.querySelector('.ticket-filter-tags');
            if(singleTicketTags.childElementCount === 10) {
                singleTicket.style.order = 1;
            }
            if(singleTicketTags.childElementCount === 9) {
                singleTicket.style.order = 2;
            }
            if(singleTicketTags.childElementCount === 8) {
                singleTicket.style.order = 3;
            }
            if(singleTicketTags.childElementCount === 7) {
                singleTicket.style.order = 4;
            }
            if(singleTicketTags.childElementCount === 6) {
                singleTicket.style.order = 5;
            }
            if(singleTicketTags.childElementCount === 5) {
                singleTicket.style.order = 6;
            }
            if(singleTicketTags.childElementCount === 4) {
                singleTicket.style.order = 7;
            }
            if(singleTicketTags.childElementCount === 3) {
                singleTicket.style.order = 8;
            }
            if(singleTicketTags.childElementCount === 2) {
                singleTicket.style.order = 9;
            }
        });

         //Hide tickets category SECTION on filter
        const ticketWrappers = document.querySelectorAll('.filterable-category-tickets');
        ticketWrappers.forEach(section => {
            const ticketsInSection = section.querySelectorAll('.merlin-ticket')
            let isTicketsInSection = false;

            ticketsInSection.forEach(ticket => {
                if(ticket.style.display.includes('flex')) {
                    isTicketsInSection = true;
                }
            })

            //Pill clicked and no other filters available
            if(e.target.classList.contains('tag-as-pill') && e.target.checked && typeOfVisitDropdownFilterInputs.length === 0 && categoryDropdownFilterSelections === null) {
                isTicketsInSection = false;
            }

            // If no tickets are visible in the section, hide the section
            if(!isTicketsInSection) {
                section.style.display = "none";
            } else {
                if(isCategoryFilterActive) {
                    section.style.display = "grid";
                } else if (isFiltersReset) {
                    section.style.display = "grid";

                    //hiddenBeforeFiltering toggle hack
                    document.querySelectorAll('.hiddenBeforeFiltering').forEach(element => {
                        element.style.display = 'none';
                    });
                }
            }
        })

        // Update Filter results count
        const localTicketsWithTagsArray = [];
        document.querySelectorAll('.filterable-type-of-visit-tickets .merlin-ticket').forEach(ticket => {
            if(ticket.style.display == "flex") {
                localTicketsWithTagsArray.push(ticket);
            }
        })

        numberOfTicketsAvailable = localTicketsWithTagsArray.length;

        document.querySelectorAll('[data-js="number-of-tickets"]').forEach(ticketCount => {
            ticketCount.innerHTML = numberOfTicketsAvailable;
        });
    }

    function categoryDropdownFilterReset() {
        categoryDropdownFilterSelections.forEach(function (radio) {
            if (radio.checked) {
                radio.checked = false;
            }
        });
        showCategoryDropdownFilterModal = !showCategoryDropdownFilterModal;
        toggleCategoryFilterModal();
    }

    function typeOfVisitDropdownFilterReset() {
        typeOfVisitDropdownFilterInputs.forEach(function (input) {
            if (input.checked) {
                input.checked = false;
            }
        });
    }

    function checkUrlForFilterParamsOnPageLoadAndUpdateSelectors(){
        const self = this;

        function queryParamsToObject(qs) {
            qs = qs.split('+').join(' ');

            var params = {},
                tokens,
                re = /[?&]?([^=]+)=([^&]*)/g;

            while (tokens = re.exec(qs)) {
                params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
            }

            return params;
        }
        const query = queryParamsToObject(document.location.search);

        // If category is set in url, set the category dropdown filter to that value
        if(query.category){
            categoryDropdownFilterSelections.forEach(function (radio) {
                if (radio.value === query.category) {
                    radio.click()
                }
            })
        }

        // If type-of-visit is set in url, set the type-of-visit dropdown filter to that value
        if(query.typeofvisit){
            query.typeofvisit.split(',').forEach(function (typeOfVisitFilter) {
                typeOfVisitDropdownFilterInputs.forEach(function (input) {
                    if (input.value === typeOfVisitFilter) {
                        input.click()
                    }
                })
            })
        }

        // If type-of-visit is set in url, set the type-of-visit dropdown filter to that value
        if(query.typeofvisit){
            query.typeofvisit.split(',').forEach(function (typeOfVisitFilter) {
                typeOfVisitPillsFilterSelections.forEach(function (input) {
                    if (input.value === typeOfVisitFilter) {
                        input.click()
                    }
                })
            })
        }
    }

    function updateUrlWithFilterParamsOnFilterPick(key, value){ //'category', 'combi tickets'
        const existingQueryString = window.location.search;
        const urlSearchParams = new URLSearchParams(existingQueryString);

        // If value is null, remove the key from the url
        if ((key === "typeofvisit" || key === "category") && value === null) {
            urlSearchParams.delete(key);
        } else {
            // If value is not null, add the key and value to the url
            urlSearchParams.set(key, value);
        }

        const params = urlSearchParams.toString();
        const hash = window.location.hash;

        history.pushState(
            null,
            null,
            `${Boolean(params) ? `?${params}` : window.location.pathname}${hash}`
        );            
    }

    function updateTypeOfVisitDropdownFilterSelectorButtonOnClick(e) {
        // Sibllng is span with label (regex removes blank space)
        const currentLabel = e.target.nextElementSibling.textContent.replace(/\s/g, '');

        typeOfVisitDropdownFilterSelector = document.querySelector('#typeOfVisitButton');
        const typeOfFilterDefaultText = typeOfVisitDropdownFilterSelector.dataset.text;
        const resetLabel = typeOfVisitDropdownFilterInputs[typeOfVisitDropdownFilterInputs.length - 1].value;

        if(e.target.value === resetLabel) {
            typeOfVisitDropdownFilterSelector.querySelector("span").innerText = typeOfFilterDefaultText;
            typeOfVisitTagLabels = [];
            return;
        } else {
            if (typeOfVisitTagLabels.length === 0) {
                typeOfVisitTagLabels.push(currentLabel);
            } else if (typeOfVisitTagLabels.includes(currentLabel)) {
                for (let i = 0; i < typeOfVisitTagLabels.length; i++) {
                    if (typeOfVisitTagLabels[i] === currentLabel) {
                        typeOfVisitTagLabels.splice(i, 1);
                    }
                }
            } else {
                typeOfVisitTagLabels.push(currentLabel);
            }
            if (typeOfVisitTagLabels.length === 0) {
                typeOfVisitDropdownFilterSelector.querySelector("span").innerHTML = typeOfVisitDropdownFilterSelector.dataset.text;
            } else {
                typeOfVisitDropdownFilterSelector.querySelector("span").innerHTML = typeOfVisitTagLabels.join(", ");
            }
        }
    }

    function disableTypeOfVisitFilterSelectionIfNoTag(tickets, filterSelections) {
        if(tickets.length === 0) {
            filterSelections.forEach(input => {
                input.disabled = true;
            })
            return
        }

        filterSelections.forEach(inputElement => {
            // Reset disabled state
            inputElement.disabled = false;


            if (inputElement.checked === false) {
                remainingAvailableTickets[inputElement.value] = 0;

                //console.log("Checking for available tickets: " + inputElement.value);

                let typeOfVisitFilterCount = 0;
                tickets.forEach(ticket => {

                    if (ticket.typeOfVisitFilters[inputElement.value] === true) {
                        remainingAvailableTickets[inputElement.value] += 1;
                    }
                })
            }
        });

        const self = this;
        for (const key in remainingAvailableTickets) {
            if (remainingAvailableTickets[key] === 0) {
                // console.log('key: ' + key)
                filterSelections.forEach(el => {
                    if (el.value === key) {
                        el.disabled = true;
                    }
                })
            }
        }
    }

    function disableCategoryFilterSelectionIfNoTag(tickets, filterSelections) {
        if(tickets.length === 0) {
            filterSelections.forEach(input => {
                input.disabled = true;
            })
            return
        }

        const localArrayOfCategories = [];
        tickets.forEach(ticket => {
            localArrayOfCategories.push(ticket.category);
        })

        const resetSelection = filterSelections[filterSelections.length - 1].value;

        filterSelections.forEach(inputElement => {
            if(inputElement.value !== resetSelection) {
                // Reset disabled state
                inputElement.disabled = false;
                if(localArrayOfCategories.includes(inputElement.value) === false) {
                    inputElement.disabled = true;
                }
            }
        })
    }

    // Open/Close modals
    function toggleTypeOfVisitDropdownFilterModalEvents() {
        const typeOfVisitFilterButtonElem = document.querySelector('[data-js="ticket-select__type-of-visit-dropdown-filter"]');

        if(typeOfVisitFilterButtonElem !== null) {
            typeOfVisitFilterButtonElem.addEventListener('click', e => {
                showTypeOfVisitDropdownFilterModal = !showTypeOfVisitDropdownFilterModal;
                toggleTypeOfVisitDropdownFilterModal();
            });
        }
    }

    function toggleTypeOfVisitDropdownFilterModal() {
        const typeOfVisitFilterButtonElem = document.querySelector('[data-js="ticket-select__type-of-visit-dropdown-filter"]');
        const typeOfVisitFilterButtonModal = document.querySelector('[data-js="ticket-select__type-of-visit-dropdown-filter-modal"]');

        if(showTypeOfVisitDropdownFilterModal) {
            if(typeOfVisitFilterButtonModal !== null) typeOfVisitFilterButtonModal.classList.add('modal--visible');
            if(typeOfVisitFilterButtonElem !== null) typeOfVisitFilterButtonElem.setAttribute('aria-expanded', 'true');
        } else {
            if(typeOfVisitFilterButtonModal !== null) typeOfVisitFilterButtonModal.classList.remove('modal--visible');
            if(typeOfVisitFilterButtonElem !== null) typeOfVisitFilterButtonElem.setAttribute('aria-expanded', 'false');
        }
    }

    function closeTypeOfVisitDropdownFilterModal(e) {
        if (!e.target.closest('.tickets-and-passes__filters__type-of-visit')) {
            showTypeOfVisitDropdownFilterModal = false;
            toggleTypeOfVisitDropdownFilterModal();
        }
    }

    function categoryFilterModalEvents() {
        const categoryFilterButtonElem = document.querySelector('[data-js="category-filter-button"]');

        if(categoryFilterButtonElem !== null) {
            categoryFilterButtonElem.addEventListener('click', e => {
                showCategoryDropdownFilterModal = !showCategoryDropdownFilterModal;
                toggleCategoryFilterModal();
            });
        }
    }

    function toggleCategoryFilterModal() {
        const categoryFilterButtonElem = document.querySelector('[data-js="category-filter-button"]');
        const categoryFilterModalElem = document.querySelector('[data-js="category-filter-modal"]');

        if(showCategoryDropdownFilterModal) {
            if(categoryFilterModalElem !== null) categoryFilterModalElem.classList.add('modal--visible');
            if(categoryFilterButtonElem !== null) categoryFilterButtonElem.setAttribute('aria-expanded', 'true');
        } else {
            if(categoryFilterModalElem !== null) categoryFilterModalElem.classList.remove('modal--visible');
            if(categoryFilterButtonElem !== null) categoryFilterButtonElem.setAttribute('aria-expanded', 'false');
        }
    }
    
    function closeCategoryFilterModal(e) {
        if (!e.target.closest('.tickets-and-passes__filters__category-filter')) {
            showCategoryDropdownFilterModal = false;
            toggleCategoryFilterModal();
        }
    }

    function revealHideTickets() {
        const revealAllTicketsBtns = document.querySelectorAll('.show-more-less-tickets-button')

        revealAllTicketsBtns.forEach(btn => {
            btn.addEventListener('click', e => {
                let hiddenTickets = e.target.closest('.merlin-tickets').querySelectorAll('.ticket-hidden');
                hiddenTickets.forEach(ticket => {
                    if(ticket.classList.contains('hidden')) {
                        ticket.classList.remove('hidden')
                    } else {
                        ticket.classList.add('hidden')
                    }
                })
                btn.classList.toggle('active');
            })
        })
    }

    function showFilterableByCategoryTickets() {
        const filterableCategoryTicketsElem = document.querySelector('[data-js="filterable-category-tickets"]');
        const notFilterableTypeOfVisitTicketsElem = document.querySelector('[data-js="not-filterable-type-of-visit-tickets"]');

        if(filterableCategoryTicketsElem !== null) {
            if(isCategoryFilterActive || isFiltersReset) {
                filterableCategoryTicketsElem.classList.remove('hidden');                
            } else {
                filterableCategoryTicketsElem.classList.add('hidden');
            }
        }
            
        if(notFilterableTypeOfVisitTicketsElem !== null) {
            if(isCategoryFilterActive || isFiltersReset) {
                notFilterableTypeOfVisitTicketsElem.classList.remove('hidden');                
            } else {
                notFilterableTypeOfVisitTicketsElem.classList.add('hidden');
            }
        }
    }

    function showFilterableByTypeOfVisitTickets() { 
        const filterableTypeOfVisitTickets = document.querySelector('[data-js="filterable-type-of-visit-tickets"]');

        if(filterableTypeOfVisitTickets !== null) {
            if(isTypeOfVisitFilterActive && !isFiltersReset && !isCategoryFilterActive) {
                filterableTypeOfVisitTickets.classList.remove('hidden');                
            } else {
                filterableTypeOfVisitTickets.classList.add('hidden');
            }            
        }
    }

    function showResultsTickets() {
        const resultsTicketsSection = document.querySelector('[data-js="results-tickets-section"]');

        if(resultsTicketsSection !== null) {
            if(isCategoryFilterActive || isTypeOfVisitFilterActive) {
                resultsTicketsSection.classList.remove('hidden');                
            } else {
                resultsTicketsSection.classList.add('hidden');
            }            
        }
    }

    init();
});